import * as React from 'react';

import useLocalStore from 'hooks/useLocalStore';

import { useBasicFormStore } from '../BasicFormStore';

import VerificationFormStore from './VerificationFormStore';

const VerificationFormStoreContext =
  React.createContext<VerificationFormStore | null>(null);

export const VerificationFormStoreProvider = ({
  children,
}: React.PropsWithChildren) => {
  const basicStore = useBasicFormStore();

  const store = useLocalStore(() => new VerificationFormStore({ basicStore }));

  return (
    <VerificationFormStoreContext.Provider value={store}>
      {children}
    </VerificationFormStoreContext.Provider>
  );
};

export const useVerificationFormStore = () => {
  const context = React.useContext(VerificationFormStoreContext);

  if (!context) {
    throw new Error('VerificationFormStoreContext is not provided');
  }

  return context;
};
